import { cx } from '@emotion/css';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import { FormGroup, FormLabel, FormText } from 'react-bootstrap';
import useFetchCompanyUsers from 'App/hooks/useFetchCompanyUsers';
import { TypeaheadInput } from 'Shared/form/TypeaheadField';

const propTypes = {
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.shape({})),
    errors: PropTypes.shape({}),
};

const defaultProps = {
    onChange: () => {},
    isDisabled: false,
    value: null,
    errors: {},
};

function UserSelector({ onChange, isDisabled, value, errors }) {
    const [searchQuery, setSearchQuery] = React.useState('');

    const { data, isLoading } = useFetchCompanyUsers({
        page: 1,
        count: 10,
        sortKey: 'firstName',
        sortOrder: 'asc',
        search: {
            fullName: searchQuery,
        },
    });

    const companyUsers = React.useMemo(() => {
        if (!data?.data) return [];
        return data.data.map((user) => ({
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
        }));
    }, [data]);

    const error = R.compose(
        R.applySpec({
            hasError: R.ifElse(R.isNil, R.F, R.propEq('users.current', 'path')),
            message: R.path(['errors', 0]),
        })
    )(errors);

    return (
        <FormGroup className={cx({ 'has-error': error.hasError })}>
            <FormLabel htmlFor="alertUsers" className="field-required">
                Assign users to receive alerts
            </FormLabel>
            <TypeaheadInput
                name="alertUsers"
                placeholder="Assign users to receive alerts"
                options={companyUsers}
                value={value}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                onChange={onChange}
                isLoading={isLoading}
                onInputChange={(input) => setSearchQuery(input)}
                isClearable
                isMulti
                isDisabled={isDisabled}
            />
            {error.hasError && <FormText>{error.message}</FormText>}
        </FormGroup>
    );
}

UserSelector.propTypes = propTypes;
UserSelector.defaultProps = defaultProps;

export default UserSelector;
